import HeaderTemplate from '@/templates/Header.template';
import PageSectionTemplate from '@/templates/PageSection.template';
import {
	Avatar,
	Box,
	Button,
	ButtonGroup,
	Flex,
	FormControl,
	FormLabel,
	IconButton,
	Input,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Text,
	Tooltip,
} from '@chakra-ui/react';
import { BiDotsVerticalRounded } from 'react-icons/bi';
import { FiTrash } from 'react-icons/fi';
import { VscChevronLeft } from 'react-icons/vsc';
import { useAvailabilityGroupDetailsPage } from './availability-group-detais.controller';
import AddParticipantModal from './components/add-participant-modal/add-participant.modal';

export default function AvailabilityGroupDetailsPage() {
	const { t, query, disclosure, goBack, handleDeleteClick, handleNameBlur, handleRemoveClick } =
		useAvailabilityGroupDetailsPage();

	if (!query.data) {
		return null;
	}

	return (
		<PageSectionTemplate>
			<HeaderTemplate
				left={
					<Button leftIcon={<VscChevronLeft />} size="sm" onClick={goBack}>
						{t('Back')}
					</Button>
				}
				center={query.data.name}
				right={
					<Menu>
						<MenuButton as={Button} colorScheme="primary" size="sm" rightIcon={<BiDotsVerticalRounded />}>
							{t('Menu')}
						</MenuButton>
						<MenuList>
							<MenuItem onClick={handleRemoveClick}>{t('Delete')}</MenuItem>
						</MenuList>
					</Menu>
				}
			/>

			<Box>
				<FormControl>
					<FormLabel>{t('Group name')}</FormLabel>
					<Input
						variant="filled"
						defaultValue={query.data.name}
						onBlur={(e) => {
							handleNameBlur(e.target.value, query.data);
						}}
					/>
				</FormControl>
				<AddParticipantModal resourceGroup={query.data} close={disclosure.onClose} isOpen={disclosure.isOpen} />
				<Flex justifyContent="space-between" alignItems="center" mt={4} mb={2}>
					<Text fontWeight={500}>{t('Members of this group')}</Text>
					<Button size="sm" colorScheme="primary" onClick={disclosure.onOpen}>
						{t('Add member')}
					</Button>
				</Flex>
				{query.data.resources
					.sort((a, b) => a.name.localeCompare(b.name))
					.map((participant) => {
						return (
							<Flex
								bg="white"
								align="center"
								gap={3}
								py={2}
								px={4}
								borderColor="gray.200"
								borderWidth={1}
								borderRadius="md"
								mb={1}
							>
								<Avatar size="sm" name={participant.name} />

								<Flex direction="column" fontSize="xs">
									<Text fontWeight="medium">{participant.name}</Text>
									<Tooltip
										hasArrow
										label={t('This availability belongs to {{email}}', { email: participant.owner.email })}
									>
										<Text color="gray.500">{participant.owner.email}</Text>
									</Tooltip>
								</Flex>

								<Box ml="auto">
									<ButtonGroup isAttached size="sm" variant="ghost">
										<Tooltip label={t('Remove')}>
											<IconButton
												icon={<FiTrash />}
												aria-label="Remove"
												onClick={() => {
													handleDeleteClick(participant.id, query.data);
												}}
											/>
										</Tooltip>
									</ButtonGroup>
								</Box>
							</Flex>
						);
					})}
			</Box>
		</PageSectionTemplate>
	);
}
